export function PdfIcon({
  size = 128,               
  ringColor = "#ff6a00",   
  docColor = "#ff6a00",     
  textColor = "#ffffff",    
  strokeWidth = 6,          
  ariaLabel = "Ícone PDF",
  showRingGlow = false,     
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      role="img"
      aria-label={ariaLabel}
      xmlns="http://www.w3.org/2000/svg"
    >
      {showRingGlow && (
        <defs>
          <filter id="ring-glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      )}

      {/* fundo branco circular */}
      <circle cx="64" cy="64" r="58" fill="#ffffff" />

      {/* anel laranja */}
      <circle
        cx="64"
        cy="64"
        r={64 - strokeWidth / 2 - 2}
        fill="none"
        stroke={ringColor}
        strokeWidth={strokeWidth}
        filter={showRingGlow ? "url(#ring-glow)" : undefined}
      />

      {/* “arquivo” com orelha (fold) */}
      <g transform="translate(34,28)">
        {/* corpo */}
        <path
          d="
            M 8 0
            H 42
            L 60 18
            V 68
            C 60 71.313 57.313 74 54 74
            H 8
            C 4.687 74 2 71.313 2 68
            V 6
            C 2 2.687 4.687 0 8 0
            Z
          "
          fill={docColor}
        />
        {/* dobra da página */}
        <path d="M42 0 L60 18 H44c-1.105 0-2-.895-2-2V0Z" fill="#ff8740" />

        {/* texto PDF */}
        <text
          x="31"
          y="49"
          textAnchor="middle"
          fontSize="22"
          fontWeight="700"
          fontFamily="Inter, Arial, Helvetica, sans-serif"
          fill={textColor}
        >
          PDF
        </text>
      </g>
    </svg>
  );
}